import React from 'react'
import {Link} from 'react-router-dom'
import {ModeleSavDossier} from '../../../../components/sav/Models'

type Props = {
  dossier: ModeleSavDossier
}

// Échange télévente : lien vers la demande de pièce de remplacement et son statut (RG16)
const SavDemandeRemplacement = ({dossier}: Props) => {
  const demande = dossier.clientDemandeRemplacement
  if (!demande) return null

  return (
    <div>
      Demande de pièce n° <strong>{demande.id}</strong>
      {demande.clientDemandeEtape && (
        <span className='badge badge-light-primary ms-2'>{demande.clientDemandeEtape.libelle}</span>
      )}{' '}
      : <Link to={`/demandes/${dossier.client.id}/traitement/${demande.id}`}>ouvrir la demande</Link>
      {dossier.commandeRemplacement ? (
        <div className='text-muted mt-1'>
          Commande {dossier.commandeRemplacement.numCommande} passée.
        </div>
      ) : (
        <div className='text-muted mt-1'>
          Le dossier passera en Commande puis se clôturera automatiquement quand la commande de la
          pièce sera passée.
        </div>
      )}
    </div>
  )
}

export default SavDemandeRemplacement
